import styled from '@emotion/styled';

const StyledFooter = styled.footer(
  {
    'marginBottom': 28,
    'marginTop': 66,
    '& ul': {
      listStyleType: 'none',
      padding: 0
    },
    '& h3': {
      marginTop: 0
    }
  },
  ({ theme }) => ({
    'color': theme.palette.text.secondary,
    '& h3': {
      fontSize: theme.typography.fontSize.large
    }
  })
);

export default StyledFooter;
